<template>
  <div class="page topic">
    <div class="top">
      <div class="icon"></div>
      <div class="title"><span>Fórum</span></div>
    </div>
    <div class="info-data">
      <template v-if="loading">
        <Sk w="44px" h="44px" rounded="rounded-full" extra="float-left mt-[22px]" />
        <div class="data flex flex-col gap-2 pt-5">
          <Sk w="70%" h="18px" />
          <Sk w="45%" h="13px" />
        </div>
      </template>
      <template v-else>
      <div class="icon-mod" :class="{'pend': topic.modder == 1, 'feched': topic.modder == 3, 'mod': topic.modder == 2}">
        <i class="fa-solid"
           :class="{'fa-check': topic.modder == 2, 'fa-lock': topic.modder == 3, 'fa-circle-exclamation': topic.modder == 1}"></i>
      </div>
      <div class="data">
        <div class="title">{{ topic.titulo }}</div>
        <div class="info"><span class="mod">{{ topic.modder_by }}</span> <span v-show="topic.modder_by !== ''">em</span>
          {{ topic.time }}
        </div>
      </div>
      </template>
    </div>
    <div class="content">
      <template v-if="loading">
        <div class="left-data">
          <div class="line"></div>
          <Sk w="80px" h="13px" extra="mx-auto mb-1" />
          <Sk w="100%" h="180px" rounded="rounded-lg" />
          <Sk w="60px" h="20px" rounded="rounded-full" extra="mx-auto mt-2" />
          <Sk w="70px" h="11px" extra="mx-auto mt-2" />
        </div>
        <div class="text flex flex-col gap-2 pt-2">
          <Sk w="100%" h="13px" />
          <Sk w="95%" h="13px" />
          <Sk w="88%" h="13px" />
          <Sk w="100%" h="13px" />
          <Sk w="75%" h="13px" />
        </div>
      </template>
      <template v-else>
      <div class="left-data">
        <div class="line"></div>
        <div class="name">{{ topic.autor }}</div>
        <div class="photo" :style="{backgroundImage: 'url('+topic.avatar+')'}"></div>
        <div class="tarja" :style="{backgroundColor: topic.tarja_cor}">{{ topic.tarja_text }}</div>
        <div class="count">{{ topic.comments }} comentários</div>
        <div class="badges">
          <div class="box" v-for="(b, i) in topic.badges" :key="i" :style="{backgroundImage: 'url('+b.badge+')'}">
            <Tooltip :title="b.title+'<br>'+b.description" top="-105%" line="25px" />
          </div>
        </div>
      </div>
      <div class="text">
        <div class="read" v-html="topic.texto"></div>
        <div class="cite"><i class="fa-solid fa-quote-right"></i></div>
      </div>
      </template>
    </div>
    <div class="fechad" v-if="topic.modder == 3">Topíco fechado</div>
    <CommentsItem type="topic" :id="id" />
    <CommentItem v-if="(store.logged == 'true' || store.logged) && topic.modder != 3" type="topic" :id="id" :user="user" />
    <Transition name="slide-fade">
      <ItemPerfil v-if="showP" @close="showP = false" :user="perfilName" />
    </Transition>
  </div>
</template>

<script setup>
import { getTopicById, getLogged } from '@/services/api.js'
import { trackEvent } from '@/services/analytics.js'
import CommentItem from '@/components/comment.vue'
import CommentsItem from '@/components/commentsTopic.vue'
import ItemPerfil from '@/components/modals/perfil.vue'
import Tooltip from '@/components/usefulness/tooltip.vue'
import Sk from '@/components/usefulness/Sk.vue'
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/stores/index.js'
import { usePageDataStore } from '@/stores/pageData.js'

const store = useStore()
const pageData = usePageDataStore()
const route = useRoute()
const router = useRouter()

const id = ref(route.params.id)
const topic = ref({})
const loading = ref(true)
const showP = ref(false)
const perfilName = ref('')
const logged = ref(false)
const user = ref('')

function applyTopic(data) {
  topic.value = data
  id.value = data.id
  loading.value = false
}

async function getTopic() {
  loading.value = true
  const cached = pageData.topic
  if (cached && String(cached.id) === String(id.value)) {
    applyTopic(cached)
    trackEvent('view_topic', { item_id: String(id.value) })
    return
  }

  const data = await getTopicById(id.value)
  if (!data[0]?.error) {
    applyTopic(data[0])
    trackEvent('view_topic', { item_id: String(id.value) })
  } else {
    loading.value = false
    await router.push({ path: '/error' })
  }
}

async function getLog() {
  const data = await getLogged()
  user.value   = data.nick ?? ''
  logged.value = data.logged
}

if (pageData.topic && String(pageData.topic.id) === String(id.value)) {
  applyTopic(pageData.topic)
}

if (loading.value) {
  getTopic()
}

getLog()

watch(
  () => route.params.id,
  (newId) => {
    id.value = newId
    getTopic()
  },
)

</script>

<style scoped>

.topic .top .icon {
  background-position: -30px -64px;
  background-color: #37758D;
}

.topic .info-data {
  float: left;
  background-color: #E6EBF1;
  border-radius: 12px;
  margin-top: 15px;
  padding: 0 20px;
  @apply w-full h-fit xl:w-[2000px] xl:h-[86px];
}

.topic .info-data .data {
  float: left;
  width: calc(100% - 54px);
  height: 100%;
  margin-left: 10px;
  @apply flex flex-col gap-2;
}

.topic .info-data .icon-mod {
  float: left;
  width: 44px;
  height: 44px;
  color: #fff;
  border-radius: 40px;
  margin-top: 22px;
  line-height: 46px;
  text-align: center;
  font-size: 16px;
}

.topic .info-data .icon-mod.pend {
  background-color: #e2e626;
}

.topic .info-data .icon-mod.mod {
  background-color: #2EC044;
}

.topic .info-data .icon-mod.feched {
  background-color: #ee3e1f;
}

.topic .info-data .title {
  width: auto;
  font-size: 18px;
  font-weight: 600;
  margin-top: 18px;
}

.topic .info-data .info {
  font-size: 13px;
  font-weight: 500;
}

.topic .info-data .info .mod {
  color: #2EC044;
}

.content {
  display: flex;
  justify-content: space-between;
  padding: 0;
}

.content .left-data {
  position: relative;
  width: 220px;
  height: auto;
  background-color: #f7f6f6;
  border-radius: 12px 0 12px 12px;
  padding: 10px 0;
}

.content .left-data .line {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 54px;
  height: 4px;
  background-color: var(--color1);
  border-radius: 0 0 4px 4px;
}

.content .left-data .name {
  width: 100%;
  height: 20px;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  margin-top: 16px;
}

.content .left-data .photo {
  width: 100%;
  height: 220px;
  background-color: #ccc;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 0 12px 0 0;
  margin-top: 25px;
}

.content .left-data .tarja {
  width: 100%;
  height: 44px;
  background-color: #35B6FF;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  line-height: 44px;
  user-select: none;
  border-radius: 0 0 12px 0;
}

.content .left-data .count {
  width: 100%;
  height: 20px;
  margin-top: 10px;
  font-size: 13px;
  font-weight: 500;
  color: #555;
  text-align: center;
  line-height: 20px;
}

.content .left-data .badges {
  width: 100%;
  height: auto;
  padding: 0 20px;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.content .left-data .badges .box {
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 6px;
}

.content .text {
  position: relative;
  width: calc(100% - 220px);
  height: auto;
}

.content .text .read {
  padding: 10px 10px 60px 10px;
  font-size: 14px;
}

.content .text .cite {
  position: absolute;
  right: 0;
  bottom: 20px;
  width: 80px;
  height: 54px;
  background-color: #E4EFF3;
  border-radius: 50px 0 0 50px;
  font-size: 16px;
  text-align: center;
  line-height: 54px;
  user-select: none;
}

.topic .fechad {
  width: 100%;
  float: left;
  height: 24px;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  margin-top: 20px;
}

@media only screen and (max-width: 500px) {
  .topic .content {
    display: block;
  }

  .topic .content .left-data {
    width: 100%;
    border-radius: 12px;
  }

  .topic .content .left-data .photo,
  .topic .content .left-data .tarja {
    border-radius: 0;
  }

  .topic .content .text {
    width: 100%;
    min-height: 140px;
  }
}
</style>
